import api from "@/plugins/api";

export const fetchMyClients = async (
  { commit },
  params = {
    next_page: 1,
    last_page: 1,
    per_page: 4,
    total: 0
  }
) => {
  const response = await api({
    method: "POST",
    endpoint: "myclients",
    body: {
      pagination: params
    }
  });

  const { data } = response;

  if (params.next_page === 1) {
    commit("resetMyClients");
  }

  commit("allClientsMutation", data);
};
